export default "__VITE_ASSET__Y2pA7qsr__"